import { Layout } from "antd";

import UserProfile from "./UserProfile";
import { useTopBar } from "./index.hook";
import styles from "./index.module.less";
import LocalStorageUtil from "../../../util/LocalStorageUtil";
import { LocalStorageConstants } from "../../../constants/ApplicationConstants/LocalStorageConstants";
import { UIStyleConstants } from "../../../constants/ApplicationConstants/UIStyleConstants";

import type { UserInterface } from "../../../shared/interface/auth/User.interface";

const { Header } = Layout;

const TopBar = () => {
  /* CONSTANTS */
  const userData = LocalStorageUtil.localStorageGetItem(LocalStorageConstants.USER_DATA) as UserInterface;

  /* HOOK */
  const config = useTopBar();

  return (
    <Header className={styles["header-container"]}>
      <div className="gx-linebar gx-mr-3 gx-d-lg-none">
        <i className={`gx-icon-btn icon icon-menu gx-text-dark`} onClick={config.handleNavCollapse} />
      </div>

      {/* <Link to="/home" className={`gx-d-block gx-d-lg-none gx-pointer ${styles["company-logo"]}`}>
        <img className={styles["img-style"]} src={wipro_pari_logo} alt="" />
      </Link> */}

      <div className={styles["header-text-container"]}>
        <span style={{ color: userData?.config?.theme?.PRIMARY_COLOR ?? UIStyleConstants.PRIMARY_COLOR }}>{userData?.config?.theme?.HEADER_TEXT || ""}</span>
      </div>

      <UserProfile />
    </Header>
  );
};

export default TopBar;
